import React from 'react';
import Header from "../../components/layout/Header";
import Banner from "../../components/home/Banner";
import Footer from "../../components/layout/Footer";

const Mobiles = () => {
    const banners = [
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/3b12ea642f89f924.jpg?q=20",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/d34fc9b3a0429712.jpg?q=20",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/62b6623631526487.jpg?q=20",
    ];

    const dealCard = (bg: string, title: string, price: string, img: string, label?: string, labelBg?: string) => (
        <div
            style={{
                backgroundColor: bg,
                borderRadius: '16px',
                padding: '16px',
                position: 'relative',
                cursor: 'pointer',
                transition: 'all 0.2s',
                minWidth: '220px',
                textAlign: 'start',
                border: '1px solid #eee',
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            {label && (
                <div
                    style={{
                        position: 'absolute',
                        top: '16px',
                        left: 0,
                        backgroundColor: labelBg || '#ffd700',
                        padding: '4px 12px',
                        borderRadius: '0 10px 10px 0',
                        fontSize: '11px',
                        fontWeight: '700',
                        zIndex: 2
                    }}
                >
                    {label}
                </div>
            )}
            <div style={{ height: '180px', marginBottom: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src={img} alt={title} style={{ height: '100%', objectFit: 'contain' }} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', textAlign: 'center' }}>
                <p style={{ fontWeight: '600', fontSize: '14px', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{title}</p>
                <span style={{ backgroundColor: '#c6f6d5', color: '#22543d', padding: '2px 8px', borderRadius: '4px', fontSize: '14px', fontWeight: '700', display: 'inline-block', margin: '4px auto 0 auto' }}>From {price}</span>
            </div>
        </div>
    );

    return (
        <div style={{ backgroundColor: '#f1f2f4', minHeight: '100vh', paddingTop: '128px' }}>
            <Header />

            <div style={{ maxWidth: '1440px', margin: '0 auto', padding: '12px 16px' }}>
                {/* Hero Banner (Auto Slider) */}
                <div style={{ marginBottom: '24px', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
                    <Banner images={banners} height="300px" />
                </div>

                {/* Brand Navigation Row */}
                <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '20px', marginBottom: '32px', boxShadow: '0 1px 2px rgba(0,0,0,0.06)' }}>
                    <h2 style={{ fontSize: '20px', marginBottom: '24px', textAlign: 'start', fontWeight: '800' }}>Shop by Brand</h2>
                    <div style={{ display: 'flex', gap: '40px', overflowX: 'auto', paddingBottom: '8px' }} className="no-scrollbar">
                        {[
                            { name: "Apple", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/1d34c62dd9806e23.jpg?q=20" },
                            { name: "Samsung", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/489f076e03328e75.jpg?q=20" },
                            { name: "Google", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/70081d77a83ee10d.jpg?q=20" },
                            { name: "Redmi", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/4a284c65154ee561.png?q=20" },
                            { name: "Realme", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/091396a84c79435b.jpg?q=20" },
                            { name: "OnePlus", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/f892a77a942a6c8e.jpg?q=20" },
                            { name: "Vivo", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/1d34c62dd9806e23.jpg?q=20" }
                        ].map((brand, i) => (
                            <div key={i} style={{ minWidth: '100px', cursor: 'pointer', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ width: '80px', height: '80px', borderRadius: '50%', backgroundColor: '#f1f2f4', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px', transition: '0.3s' }}>
                                    <img src={brand.img} alt={brand.name} style={{ height: '100%', objectFit: 'contain' }} />
                                </div>
                                <p style={{ fontSize: '12px', fontWeight: '700', marginTop: '8px', margin: '8px 0 0 0' }}>{brand.name}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Flagship Section - Large Cards */}
                <div style={{ marginBottom: '32px' }}>
                    <h2 style={{ fontSize: '22px', marginBottom: '16px', textAlign: 'start', fontWeight: '800' }}>Flagship Collection</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '24px' }}>
                        {[
                            { title: "iPhone 15 Pro", off: "Just ₹1,29,900", img: "https://rukminim1.flixcart.com/image/416/416/xif0q/mobile/h/d/9/-original-imagtc2qzgnnuhxh.jpeg?q=70" },
                            { title: "Galaxy S24 Ultra", off: "Min. ₹10,000 Off", img: "https://rukminim1.flixcart.com/image/416/416/xif0q/mobile/5/i/7/-original-imagxbp98mdfy6hp.jpeg?q=70" }
                        ].map((item, i) => (
                            <div
                                key={i}
                                style={{
                                    backgroundColor: 'white',
                                    borderRadius: '24px',
                                    padding: '32px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    transition: '0.3s'
                                }}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'flex-start' }}>
                                    <span style={{ backgroundColor: '#ebf8ff', color: '#2b6cb0', padding: '2px 12px', borderRadius: '999px', fontWeight: '800', fontSize: '12px' }}>NEW LAUNCH</span>
                                    <h3 style={{ fontSize: '24px', fontWeight: '900', margin: 0 }}>{item.title}</h3>
                                    <p style={{ fontWeight: '800', color: '#3182ce', fontSize: '18px', margin: 0 }}>{item.off}</p>
                                    <button style={{ backgroundColor: '#3182ce', color: 'white', padding: '10px 40px', borderRadius: '999px', fontWeight: '800', border: 'none', cursor: 'pointer' }}>Shop Now</button>
                                </div>
                                <img src={item.img} alt={item.title} style={{ height: '200px' }} />
                            </div>
                        ))}
                    </div>
                </div>

                {/* No Cost EMI */}
                <div style={{ marginBottom: '48px' }}>
                    <h2 style={{ fontSize: '20px', marginBottom: '16px', textAlign: 'start', fontWeight: '800' }}>No Cost EMI Stores</h2>
                    <div style={{ display: 'flex', gap: '16px', overflowX: 'auto', paddingBottom: '16px' }} className="no-scrollbar">
                        {dealCard("#ffffff", "iPhone 16", "₹6,711/m", "https://rukminim1.flixcart.com/image/312/312/xif0q/mobile/4/5/b/-original-imagtc5y6uyygqg2.jpeg?q=70", "0% Interest", "yellow")}
                        {dealCard("#ffffff", "Vivo V30", "₹1,833/m", "https://rukminim1.flixcart.com/image/312/312/xif0q/mobile/h/d/9/-original-imagtc2qzgnnuhxh.jpeg?q=70", "Best Seller", "yellow")}
                        {dealCard("#ffffff", "Moto G64", "₹1,499/m", "https://rukminim1.flixcart.com/image/312/312/xif0q/mobile/m/a/9/-original-imahf4r9f9gzshge.jpeg?q=70", "Under ₹15k", "yellow")}
                        {dealCard("#ffffff", "Redmi Note 13", "₹1,249/m", "https://rukminim1.flixcart.com/image/312/312/xif0q/mobile/c/f/v/-original-imagwadkhedhefhj.jpeg?q=70", "Top Rated", "yellow")}
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    );
};

export default Mobiles;

